import { Egenskapsfilter } from '@/middleware/queries/Egenskapsfilter';
import {
    AdvancedFilterEgenskapNode,
    AdvancedFilterGroupNode,
    createAdvancedFilterEgenskapNode,
    createAdvancedFilterGroup,
    createAdvancedFilterRoot,
} from './AdvancedFilterTypes';

export function migrateLegacyFiltersToAdvancedFilter(
    filters: Egenskapsfilter[]
): AdvancedFilterGroupNode | null {
    const validFilters = filters.filter(filter => filter.isValid());
    if (validFilters.length === 0) {
        return null;
    }

    const groupedFilters = validFilters.reduce((accumulator, filter) => {
        const propertyId = filter.egenskapstype.id;
        accumulator.set(propertyId, [...(accumulator.get(propertyId) ?? []), filter]);
        return accumulator;
    }, new Map<number, Egenskapsfilter[]>());

    const children: (AdvancedFilterGroupNode | AdvancedFilterEgenskapNode)[] = Array.from(
        groupedFilters.values()
    ).map(propertyFilters => {
        const propertyChildren = propertyFilters.map(filter =>
            createAdvancedFilterEgenskapNode(
                filter.egenskapstype,
                filter.operator,
                filter.verdi
            )
        );

        if (propertyChildren.length === 1) {
            return propertyChildren[0];
        }

        const operator = propertyFilters[0].egenskapstype.erEnum() ? 'OR' : 'AND';
        return createAdvancedFilterGroup(operator, propertyChildren);
    });

    return createAdvancedFilterRoot(children);
}
